import { OAuthProvider, signInWithPopup, signInWithRedirect } from 'firebase/auth';
import { auth } from '../backend/firebase';
import { persistor } from '../redux/store';

const provider = new OAuthProvider('apple.com');
provider.addScope('email');
provider.addScope('name');

/**
 * Apple sign-in with the same popup→redirect fallback used by signInWithGoogle
 * (handles popup blockers and iOS Safari). AuthProvider reacts to the resulting
 * auth state change, so the post-sign-in flow (assigned color, tile upgrade) is
 * identical to Google.
 *
 * Requires the Apple provider to be enabled in the Firebase console with a
 * configured Services ID / return URL — client code only.
 */
export async function signInWithApple(): Promise<void> {
    try {
        await signInWithPopup(auth, provider);
    } catch (err: any) {
        if (err?.code === 'auth/popup-blocked' || err?.code === 'auth/popup-closed-by-user') {
            await persistor.flush();
            await signInWithRedirect(auth, provider);
        } else {
            console.error('Sign-in error:', err);
        }
    }
}
